import { InjectionToken } from '@angular/core';

export interface BugsnagConfiguration {
  bugsnagApiKey: string;
  appVersion: string;
  autoCaptureSessions: boolean;
  notifyReleaseStages: Array<string>;
  enableRemoteErrorLogging: boolean;
  releaseStage: string;
}

export const BUG_SNAG_CONFIGURATION = new InjectionToken<BugsnagConfiguration>('BugsnagConfiguration');
